import React, { useState, useEffect } from "react";
import {
  APITypes,
  SubscriptionFrom,
  SubscriptionFromErr,
  isAlgoVendors,
  TITLE,
} from "../../../Containers/vendor/MySubscriptions/subscriptionsConstent";
import DragAndDrop from "../../generic/dragAndDrop";
import InputField from "../../generic/inputField";
import RadioButton from "../../generic/radioButton";
import { IListObj } from "../../types/genericTypes";
import { redircetUrlValidate, validateAppIcon } from "../../utils/formValidate";
import { betweenNChars, ValidateIPaddress } from "../../utils/regex";
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import {staticIpPrimaryValidate,staticIpSecondaryValidate,appNameValidate } from '../../utils/formValidate'
import ChartTocDropdown from "../DashBoard/generic/ChartTocDropdown";
import TocDropdown from "../../generic/tocDropdown";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: '#EBE9FF',
    color: '#4F4E70',
    fontSize: '12px',
    padding: '10px 12px',
    maxWidth: 280,
    borderRadius: 8,
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  },
  arrow: {
    color: '#EBE9FF',
  },
}));
export interface ISubscriptionFormProps {
  isSubFrom: any;
  APITypes: Array<IListObj>;
  subscriptionFrom: SubscriptionFrom;
  subscriptionFromErr: SubscriptionFromErr;
  ipCount: number;
  setIpCount: (ipCount: number) => void;
  setSubscriptionFromErr: (value: any) => void;
  onChangeFormVal: (value: any) => void;
  submitFromHandler: () => void;
  handelSubscriptionModal: (
    isOpen: boolean,
    title: string,
    appData: any
  ) => void;
}

const SubscriptionForm: React.FC<ISubscriptionFormProps> = (props) => {
  const [imgPicker, setImgPicker] = useState<any>("");
  const [enableAssist, setEnableAssist] = useState<boolean>(false);
  // const [ipCountArray, setIpCount] = useState<any>([]);
  const classes = useStyles();
  const removeImage = () => {
    delete props.subscriptionFrom.appIcon;
    delete props.subscriptionFrom.iconView;
    props.onChangeFormVal({
      ...props.subscriptionFrom,
    });
  };
  // const ipCountHandler = async (key: number, count: number) => {
  //   if (count < props.ipCount) {
  //     props.subscriptionFrom.ip.splice(key, 1);
  //     props.subscriptionFromErr.ip.splice(key, 1);
  //   } else if (count > props.ipCount) {
  //     props.subscriptionFrom.ip.splice(key + 1, 0, "");
  //     props.subscriptionFromErr.ip.splice(key + 1, 0, "");
  //   }
  //   await props.setIpCount(count);
  //   IPFieldCreater();
  //   props.onChangeFormVal(props.subscriptionFrom);
  //   props.setSubscriptionFromErr(props.subscriptionFromErr);
  // };

  // const IPFieldCreater = () => {
  //   return props.subscriptionFrom.ip.map((ip: any, i: number) => {
  //     if (i === 0) {
  //       return (
  //         <div key={i} className="custom-col-12 align-center">
  //           <div className="custom_col_5">
  //             <label htmlFor="nuvama_id">IP Filtering Details</label>
  //           </div>
  //           <div className="custom_col_7">
  //             <InputField
  //               id={ip}
  //               defaultValue={ip}
  //               getValue
  //               onChange={(val) => {
  //                 props.subscriptionFrom.ip[i] = val;
  //                 props.onChangeFormVal({
  //                   ...props.subscriptionFrom,
  //                   ip: [...props.subscriptionFrom.ip],
  //                 });
  //               }}
  //               onBlur={(error) => {
  //                 props.setSubscriptionFromErr({
  //                   ...props.subscriptionFromErr,
  //                   ip: [
  //                     error.value
  //                       ? ValidateIPaddress.test(error.value)
  //                         ? (props.subscriptionFromErr.ip[i] = "")
  //                         : (props.subscriptionFromErr.ip[i] =
  //                             "Please enter a valid ip address")
  //                       : (props.subscriptionFromErr.ip[i] = ""),
  //                   ],
  //                 });
  //               }}
  //               className="subs_input w_60"
  //               autoComplete="off"
  //               errorText={props.subscriptionFromErr.ip[i]}
  //             />

  //             <div className="ip_btn_box">
  //               <div className="ip_btn">
  //                 <span
  //                   className="blue-txt"
  //                   onClick={() => ipCountHandler(i, props.ipCount + 1)}
  //                 >
  //                   <i className="edel-icon-expand"></i>Add
  //                 </span>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       );
  //     } else {
  //       return (
  //         <div key={i} className="custom-col-12 align-center">
  //           <div className="custom_col_5"></div>
  //           <div className="custom_col_7">
  //             <InputField
  //               id={ip}
  //               defaultValue={ip}
  //               getValue
  //               onChange={(val) => {
  //                 props.subscriptionFrom.ip[i] = val;
  //                 props.onChangeFormVal({
  //                   ...props.subscriptionFrom,
  //                   ip: [...props.subscriptionFrom.ip],
  //                 });
  //               }}
  //               onBlur={(error) => {
  //                 let isValid = !ValidateIPaddress.test(error.value)
  //                   ? "Please enter a valid ip address or you can delete field"
  //                   : "";
  //                 props.subscriptionFromErr.ip[i] = isValid;
  //                 props.setSubscriptionFromErr({
  //                   ...props.subscriptionFromErr,
  //                   ip: [...props.subscriptionFromErr.ip],
  //                 });
  //               }}
  //               className="subs_input w_60"
  //               errorText={props.subscriptionFromErr.ip[i]}
  //               autoComplete="off"
  //             />

  //             <div className="ip_btn_box">
  //               <div className="ip_btn">
  //                 <span
  //                   className="blue-txt"
  //                   onClick={() => ipCountHandler(i, props.ipCount + 1)}
  //                 >
  //                   <i className="edel-icon-expand"></i>Add
  //                 </span>
  //               </div>
  //               {props.ipCount > 1 && (
  //                 <div className="ip_btn">
  //                   <span
  //                     className="text_red"
  //                     onClick={() => ipCountHandler(i, props.ipCount - 1)}
  //                   >
  //                     <i className="edel-icon-trash"></i> Delete
  //                   </span>
  //                 </div>
  //               )}
  //             </div>
  //           </div>
  //         </div>
  //       );
  //     }
  //   });
  // };

  // const submitForm = () => {
  //   // props.submitFromHandler
  //   let rdUrlValidate = redircetUrlValidate(props.subscriptionFrom.rdUrl);
  //   if (
  //     props.subscriptionFrom.appNm.length > 50 ||
  //     props.subscriptionFrom.appNm.length < 4
  //   ) {
  //     props.setSubscriptionFromErr({
  //       ...props.subscriptionFromErr,
  //       appNm: "App name must have minimum 4 and maximum 50 characters",
  //     });
  //   } 
  //   // else if (
  //   //   props.subscriptionFrom.ip.length > 1 &&
  //   //   props.subscriptionFrom.ip.includes("")
  //   // ) {
  //   //   let ipErr = [];
  //   //   for (let i = 0; i < props.subscriptionFrom.ip.length; i++) {
  //   //     if (props.subscriptionFrom.ip[i] === "") {
  //   //       ipErr.push("Ip address is required or you can delete");
  //   //     } else {
  //   //       ipErr.push("");
  //   //     }
  //   //   }
  //   //   props.setSubscriptionFromErr({
  //   //     ...props.subscriptionFromErr,
  //   //     ip: ipErr,
  //   //   });
  //   // } 
  //   else if(staticIpPrimaryValidate(props.subscriptionFrom.primaryIp)){
  //     props.setSubscriptionFromErr({
  //       ...props.subscriptionFromErr,
  //       primaryIp: staticIpPrimaryValidate(props.subscriptionFrom.primaryIp),
  //     });
  //     return;
  //   }else if(staticIpSecondaryValidate(
  //   props.subscriptionFrom.secondaryIp,
  //   props.subscriptionFrom.primaryIp
  // )){
  //     props.setSubscriptionFromErr({
  //       ...props.subscriptionFromErr,
  //       secondaryIp: staticIpSecondaryValidate(
  //   props.subscriptionFrom.secondaryIp,
  //   props.subscriptionFrom.primaryIp
  // ),
  //     });
  //     return;
  //   }
  //   else if (rdUrlValidate !== true) {
  //     props.setSubscriptionFromErr({
  //       ...props.subscriptionFromErr,
  //       rdUrl: rdUrlValidate,
  //     });
  //   } else if (
  //     props.subscriptionFrom.type === "" ||
  //     props.subscriptionFrom.type === undefined
  //   ) {
  //     props.setSubscriptionFromErr({
  //       ...props.subscriptionFromErr,
  //       ldId: "Please select API type",
  //     });
  //   } else {
  //     console.log("else hit");
  //     props.setSubscriptionFromErr({
  //       ...props.subscriptionFromErr,
  //       // ip: [],
  //     });
  //     console.log('SubscriptionForm',SubscriptionForm)
  //     // props.submitFromHandler();
  //   }
  // };
  const submitForm = () => {
  const { appNm, primaryIp, secondaryIp, rdUrl, type, isAlgoVendor } = props.subscriptionFrom;

  const appNameRes = appNameValidate(appNm);
  const staticPrimaryRes = staticIpPrimaryValidate(primaryIp);
  const staticSecondaryRes = staticIpSecondaryValidate(secondaryIp, primaryIp);
  const rdUrlRes = redircetUrlValidate(rdUrl);
  if (appNameRes !== true) {
    props.setSubscriptionFromErr({
      ...props.subscriptionFromErr,
      appNm: appNameRes,
    });
    return;
  }
   if (typeof isAlgoVendor === "string" && isAlgoVendor === "") {
    props.setSubscriptionFromErr({
      ...props.subscriptionFromErr,
      isAlgoVendor: "Please select a partner type.",
    });
    return;
  }

  if(isAlgoVendor){
    if (staticPrimaryRes !== true) {
      props.setSubscriptionFromErr({
        ...props.subscriptionFromErr,
        primaryIp: staticPrimaryRes,
      });
      return;
    }
  
    if (staticSecondaryRes !== true) {
      props.setSubscriptionFromErr({
        ...props.subscriptionFromErr,
        secondaryIp: staticSecondaryRes,
      });
      return;
    }
  }

  if (rdUrlRes !== true) {
    props.setSubscriptionFromErr({
      ...props.subscriptionFromErr,
      rdUrl: rdUrlRes,
    });
    return;
  }

  if (type === "" || type === undefined) {
    props.setSubscriptionFromErr({
      ...props.subscriptionFromErr,
      ldId: "Please select API type",
    });
    return;
  }

  // All validations passed
  props.setSubscriptionFromErr({
    ...props.subscriptionFromErr,
    appNm: "",
    primaryIp: "",
    secondaryIp: "",
    rdUrl: "",
    ldId: "",
    isAlgoVendor: ""
  });
  props.submitFromHandler();
};

  useEffect(() => {
    if (imgPicker.length > 0) {
      let validateIcon = validateAppIcon(imgPicker[0]);
      if (validateIcon === true) {
        props.onChangeFormVal({
          ...props.subscriptionFrom,
          appIcon: imgPicker[0],
          iconView: URL.createObjectURL(imgPicker[0]),
        });
        props.setSubscriptionFromErr({
          ...props.subscriptionFromErr,
          appIcon: "",
        });
      } else {
        props.setSubscriptionFromErr({
          ...props.subscriptionFromErr,
          appIcon: validateIcon,
        });
      }
    }
  }, [imgPicker]);

  return (
    <div id={props.isSubFrom.isOpen ? "show_modal" : "hide_modal"}>
      <div className="modal_MyApp modal_subscription">
        <div className="modal_content_myApp createApp">
          <div>
            <div>
              <h2 className="head">{props.isSubFrom.title}</h2>
            </div>
            <div className="createAppWrap mob_view">
              <div className="custom-col-12 align-center">
                <div className="custom_col_5 mob_view">
                  <label htmlFor="appName">App Name*</label>
                </div>
                <div className="custom_col_7 fd-column">
                  <InputField
                    id="appNm"
                    required
                    pattern={betweenNChars(4, 50)}
                    maxLength={50}
                    defaultValue={props.subscriptionFrom.appNm}
                    onChange={(val) => {
                      props.onChangeFormVal({
                        ...props.subscriptionFrom,
                        appNm: val,
                      });
                    }}
                    onBlur={(error) => {
                      let appNm = "";
                      if (error.required) appNm = "App name is required";
                      if (!error.pattern) {
                        appNm =
                          "App name must have minimum 4 and maximum 50 characters";
                      }
                      props.setSubscriptionFromErr({
                        ...props.subscriptionFromErr,
                        appNm: appNm,
                      });
                    }}
                    className="subs_input "
                    errorText={props.subscriptionFromErr.appNm}
                    autoComplete="off"
                    suffix={`${props.subscriptionFrom.appNm.length} / 50`}
                  />
                </div>
              </div>
              <div className="custom-col-12 input_msg">
                <div className="custom_col_5 mob_view">
                  {/* <label htmlFor="appName">App Name*</label> */}
                </div>
                <div className="custom_col_7 fd-column">
                  <p className="txt_grey ">
                    Please select a name which represents your company, as this
                    name will be used for all future communications and to will
                    be visible to the clients
                  </p>
                </div>
              </div>

              {(props.isSubFrom.title === TITLE.CREATE || props.subscriptionFrom.isAlgoVendor || props.subscriptionFrom.isAlgoVendor === "") && (
                <>
                  {/* Partner Type Dropdown */}
                  <div className="custom-col-12 align-center">
                    <div className="custom_col_5 mob_view">
                      <label htmlFor="partnerType" style={{marginRight:'8px'}}>Partner Type</label>
                    </div>
                    <div className="custom_col_7 fd-column">
                      <TocDropdown
                        selectedValue={props.subscriptionFrom.isAlgoVendor}
                        dropdownOptions={isAlgoVendors}
                        onSelect={(val: any) => {
                          props.onChangeFormVal({
                            ...props.subscriptionFrom,
                            isAlgoVendor: val,
                          });
                          props.setSubscriptionFromErr({
                            ...props.subscriptionFromErr,
                            isAlgoVendor: '',
                          });
                        }}
                        isSearchable={false}
                        disabled={
                          props.isSubFrom.title === TITLE.EDIT && 
                          typeof props.subscriptionFrom.isAlgoVendor === "boolean"
                        }
                        />
                        <div>
                          {props.subscriptionFromErr.isAlgoVendor !== "" && (
                            <span className="form-err">
                              {props.subscriptionFromErr.isAlgoVendor}
                            </span>
                          )}
                        </div>
                    </div>
                  </div>
                </>
              )}
              {/* Conditionally render IP fields only when isAlgoVendor is "algo" */}
              {(props.subscriptionFrom.isAlgoVendor === true) && (
                <>
                  {/* Static IP Primary */}
                  <div className="custom-col-12 align-center">
                    <div className="custom_col_5 mob_view">
                      <label htmlFor="staticIP_Primary" style={{marginRight:'8px'}}>Static IP Primary*</label>
                      <Tooltip
                        title={
                          <>
                            <p>
                              To comply with SEBI's latest circular on algorithmic
                              trading, all users accessing APIs must register a static
                              IP address. Mandatory before April 1st, 2026.
                            </p>
                            <br />
                            <br />
                            <p>
                              Contact your Internet Service Provider and request a
                              Static IP.
                            </p>
                          </>
                        }
                        arrow
                        placement="bottom"
                        classes={{
                          tooltip: classes.customTooltip,
                          arrow: classes.arrow,
                        }}
                      >
                        <i className="edel-icon-tooltip" style={{color:'#6374D4'}}></i>
                      </Tooltip>
                    </div>
                    <div className="custom_col_7 fd-column">
                      <InputField
                        id="primaryIp"
                        required
                        defaultValue={props.subscriptionFrom.primaryIp}
                        onChange={(val) => {
                          props.onChangeFormVal({
                            ...props.subscriptionFrom,
                            primaryIp: val,
                          })
                        }}
                        onBlur={(error) => {
                          let err = "";
                          if (error.value && !ValidateIPaddress.test(error.value)) {
                            err = "Invalid IP format";
                          }
                          props.setSubscriptionFromErr({
                            ...props.subscriptionFromErr,
                            primaryIp: err,
                          });
                        }}
                        className="subs_input"
                        errorText={props.subscriptionFromErr.primaryIp}
                        autoComplete="off"
                        disabled={!Boolean(props.subscriptionFrom?.ipEditable)}
                      />
                      <span className="static_Ip_note">
                        Please Note: The IP address can only be changed once in a
                        calendar week.
                      </span>
                    </div>
                  </div>

                  {/* Static IP Secondary */}
                  <div className="custom-col-12 align-center">
                    <div className="custom_col_5 tooltip mob_view">
                      <label htmlFor="staticIP_Secondary" style={{marginRight:'8px'}}>Static IP Secondary</label>
                      <Tooltip
                        title={
                          <>
                            <p>
                              A backup or additional IP address that can handle requests
                              if the primary fails or is overloaded.
                            </p>
                          </>
                        }
                        arrow
                        placement="bottom"
                        classes={{
                          tooltip: classes.customTooltip,
                          arrow: classes.arrow,
                        }}
                      >
                        <i className="edel-icon-tooltip" style={{color:'#6374D4'}}></i>
                      </Tooltip>
                    </div>
                    <div className="custom_col_7 fd-column">
                      <InputField
                        id="secondaryIp"
                        required
                        defaultValue={props.subscriptionFrom.secondaryIp}
                        onChange={(val) => {
                          props.onChangeFormVal({
                            ...props.subscriptionFrom,
                            secondaryIp: val,
                          })
                        }}
                        onBlur={(error) => {
                          let err = "";
                          if (error.value && !ValidateIPaddress.test(error.value)) {
                            err = "Invalid IP format";
                          }
                          props.setSubscriptionFromErr({
                            ...props.subscriptionFromErr,
                            secondaryIp: err,
                          });
                        }}
                        className="subs_input"
                        errorText={props.subscriptionFromErr.secondaryIp}
                        autoComplete="off"
                        disabled={!Boolean(props.subscriptionFrom?.ipEditable)}
                      />
                    </div>
                  </div>
                </>
              )}
    
              <div className="custom-col-12 align-center">
                <div className="custom_col_5">
                  <div className="redirectUrl">
                    <label htmlFor="redirectUrl">Redirect URL</label>
                    <span
                      className="txt_blue"
                      onClick={() => setEnableAssist(true)}
                    >
                      Enable Assist
                    </span>
                  </div>
                </div>
                <div className="custom_col_7">
                  <InputField
                    id="rdUrl"
                    required={
                      props.subscriptionFrom.type === APITypes[0].value
                        ? true
                        : false
                    }
                    getValue
                    defaultValue={props.subscriptionFrom.rdUrl}
                    onChange={(rdUrl) => {
                      props.onChangeFormVal({
                        ...props.subscriptionFrom,
                        rdUrl,
                      });
                    }}
                    onBlur={(error) => {
                      let rdUrl = "";
                      if (error.required) rdUrl = "Redirect url is required";
                      if (error.value.length > 0) {
                        let checkUrl = redircetUrlValidate(error.value);
                        if (checkUrl !== true) {
                          rdUrl = checkUrl;
                        }
                      }
                      props.setSubscriptionFromErr({
                        ...props.subscriptionFromErr,
                        rdUrl: rdUrl,
                      });
                    }}
                    className="subs_input "
                    placeholder="Eg:5678987"
                    errorText={props.subscriptionFromErr.rdUrl}
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="custom-col-12 align-center">
                <div className="custom_col_5">
                  <div className="redirectUrl">
                    <label htmlFor="redirectUrl">API Type</label>
                  </div>
                </div>
                <div className="custom_col_7 fd-column ">
                  <div className="subscription_radio_btn">
                    {props.APITypes.map((type, i) => {
                      return (
                        <RadioButton
                          key={i}
                          list={type}
                          name={"type"}
                          // disabled={
                          //   props.isSubFrom.title === TITLE.EDIT ? true : false
                          // }
                          selected={
                            props.subscriptionFrom.type === APITypes[0].value
                              ? APITypes[0].value
                              : APITypes[1].value
                          }
                          onChange={(e) => {
                            props.setSubscriptionFromErr({
                              ...props.subscriptionFromErr,
                              type: "",
                            });
                            if (e.target.value !== APITypes[0].value) {
                              props.setSubscriptionFromErr({
                                ...props.subscriptionFromErr,
                                rdUrl: "",
                              });
                            }
                            props.onChangeFormVal({
                              ...props.subscriptionFrom,
                              [e.target.name]: e.target.value,
                            });
                          }}
                          moduleName={"subscriptionFrom_radio"}
                        />
                      );
                    })}
                  </div>

                  <div>
                    {props.subscriptionFromErr.type !== "" && (
                      <span className="form-err">
                        {props.subscriptionFromErr.type}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="custom-col-12 align-center">
                <div className="custom_col_5">
                  <label htmlFor="appIcon">App Icon</label>
                  <span className="txt_grey">(Optional)</span>
                </div>
                <div className="custom_col_7 fd-column">
                  {props.subscriptionFrom && props.subscriptionFrom.iconView ? (
                    <div className="imageViewer">
                      <div className="imageViewer_left">
                        <img
                          src={props.subscriptionFrom.iconView}
                          alt="app-Icon"
                          className="avatar"
                        />
                        <span className="ingSrc">
                          {props.subscriptionFrom.appIcon.name}
                        </span>
                      </div>
                      <div>
                        <span className="pointer" onClick={removeImage}>
                          <span>Remove</span>
                          <i className="edel-icon-close"></i>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <DragAndDrop onChange={setImgPicker} />
                  )}
                  {props.subscriptionFromErr.appIcon !== "" && (
                    <span className="form-err">
                      {props.subscriptionFromErr.appIcon}
                    </span>
                  )}
                </div>
                {/* </div> */}
                {/* <div className="text">
              <p>An amount of <span>₹2,000</span> will be charged to activate this app</p>
            </div>  */}
              </div>
              <div className="display-flex w-100 desktopAppFormBtn">
                <button
                  onClick={() => props.handelSubscriptionModal(false, "", "")}
                  className="custom-btn border-btn w-30"
                >
                  Cancel
                </button>
                <button
                  className="custom-btn block-btn w-70"
                  onClick={submitForm}
                >
                  {props.isSubFrom.title === TITLE.CREATE ? "Create" : "Save"}
                </button>
              </div>
              <div className="mob_footer">
                <div className="mobAppFormBtn">
                  <button
                    onClick={() => props.handelSubscriptionModal(false, "", "")}
                    className="custom-btn border-btn "
                  >
                    Cancel
                  </button>
                  <button
                    className="custom-btn block-btn "
                    onClick={submitForm}
                  >
                    {props.isSubFrom.title === TITLE.CREATE ? "Create" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id={enableAssist ? "show_modal" : "hide_modal"}>
          <div className="assistModal">
            <div className="assistModal_container">
              <div className="assistModal_head">
                <p>Redirect URL</p>
                <span onClick={() => setEnableAssist(false)}>
                  {" "}
                  <i className="edel-icon-close"></i>
                </span>
              </div>
              <div className="assistModal_content">
                <p>
                  Register a redirect_url with us when you create an App for
                  redirection after client login. e.g.{" "}
                  <a
                    target="_blank"
                    href="https://yoursite.com/edel-redirect"
                    rel="noreferrer"
                  >
                    {" "}
                    https://yoursite.com/edel-redirect.
                  </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionForm;
